// extracted by mini-css-extract-plugin
export default {"container":"index_container__c+fdj","textContainer":"index_textContainer__8g8A9","title":"index_title__sjSlm","subtitle":"index_subtitle__AIFc+","button":"index_button__IP4YG"};